import React from 'react';
import { useTranslation } from 'react-i18next';
import './WelcomeDialog.css';

function WelcomeDialog({ show, onStartTour, onDismiss, title, message, primaryLabel, secondaryLabel }) {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="welcome-overlay" onClick={onDismiss}>
      <div className="welcome-dialog" onClick={(e) => e.stopPropagation()}>
        <h2 className="welcome-title">{title || t('onboarding.welcomeTitle')}</h2>
        <div className="welcome-message">{message || t('onboarding.welcomeMessage')}</div>
        <div className="welcome-actions">
          <button className="welcome-btn-primary" onClick={onStartTour}>
            {primaryLabel || t('onboarding.showMeAround')}
          </button>
          <button className="welcome-btn-secondary" onClick={onDismiss}>
            {secondaryLabel || t('onboarding.noThanks')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeDialog;
